// import React from 'react';
// import {
//   FolderOpen, Activity, CheckCircle
// } from 'lucide-react';
// import MetricCard from './MetricCard';

// const ProjectsDashboard = ({ stats, dashboardData }) => {

//   console.log("stats",stats);
//   console.log("dashboardData",dashboardData);
  
//   return (
//     <div className="space-y-6">
//       {/* Project Metrics */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         <MetricCard icon={<FolderOpen className="w-6 h-6" />} title="Total Projects" value={stats.totalProjects} change="+10%" trend="up" color="blue" />
//         <MetricCard icon={<Activity className="w-6 h-6" />} title="Active Projects" value={stats.activeProjects} change="+15%" trend="up" color="green" />
//         <MetricCard icon={<CheckCircle className="w-6 h-6" />} title="Completed" value={stats.completedProjects} change="+5%" trend="up" color="purple" />
//       </div>

//       {/* Project Timeline */}
//       <div className="bg-white rounded-xl shadow-sm p-6">
//         <h3 className="text-lg font-semibold text-gray-900 mb-4">Project Timeline</h3>
//         {dashboardData.projectStatus.length > 0 ? (
//           <div className="space-y-4">
//             {dashboardData.projectStatus.map((status) => (
//               <div key={status.name} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
//                 <div className="flex-1">
//                   <div className="flex items-center justify-between mb-2">
//                     <span className="font-medium text-gray-900">{status.name}</span>
//                     <span className={`px-2 py-1 rounded-full text-xs ${
//                       status.name === 'Completed' ? 'bg-green-100 text-green-800' :
//                       status.name === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
//                       'bg-red-100 text-red-800'
//                     }`}>
//                       {status.name}
//                     </span>
//                   </div>
//                                     <div className="w-full bg-gray-200 rounded-full h-2">
//                     <div className={`h-2 rounded-full ${
//                       status.name === 'Completed' ? 'bg-green-500' :
//                       status.name === 'In Progress' ? 'bg-yellow-500' : 'bg-red-500'
//                     }`} style={{ width: `${(status.value / stats.totalProjects) * 100}%` }}></div>
//                   </div>
//                   <div className="flex justify-between text-xs text-gray-500 mt-1">
//                     <span>{status.value} projects</span>
//                     <span>Progress: {(status.value / stats.totalProjects * 100).toFixed(0)}%</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p className="text-gray-500 text-center py-8">No project data available</p>
//         )}
//       </div>

//       {/* Recent Milestones Table */}
//       <div className="bg-white rounded-xl shadow-sm p-6">
//         <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Milestones</h3>
//         {dashboardData.upcomingDeadlines.filter(d => d.type === 'Milestone').length > 0 ? (
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Project</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Due Date</th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {dashboardData.upcomingDeadlines.filter(d => d.type === 'Milestone').slice(0, 5).map((milestone, index) => (
//                   <tr key={index} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{milestone.title || milestone.name}</td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{milestone.projectName}</td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`px-2 py-1 rounded-full text-xs ${
//                         milestone.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                       }`}>
//                         {milestone.status || 'In Progress'}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(milestone.dueDate).toLocaleDateString()}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <p className="text-gray-500 text-center py-8">No milestones data available</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProjectsDashboard;




import React, { useState, useEffect } from 'react';
import { FolderOpen, Activity, CheckCircle } from 'lucide-react';
import {jwtDecode} from 'jwt-decode';
import MetricCard from './MetricCard';

const ProjectsDashboard = ({ stats, dashboardData }) => {
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const [filteredProjectStatus, setFilteredProjectStatus] = useState([]);
  const [filteredUpcomingDeadlines, setFilteredUpcomingDeadlines] = useState([]);
  const [filteredStats, setFilteredStats] = useState(stats);

  useEffect(() => {
    // Get user role and id from token
    const token = localStorage.getItem("authToken");
    if (!token) {
      setUserRole(null);
      setUserId(null);
      // Show all for fallback
      setFilteredProjectStatus(dashboardData.projectStatus);
      setFilteredUpcomingDeadlines(dashboardData.upcomingDeadlines);
      setFilteredStats(stats);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const role = decodedToken.role?.toLowerCase();
      const id = decodedToken.id;
      setUserRole(role);
      setUserId(id);

      if (role === 'employee') {
        // Filter projects in projectStatus by assigned employee
        const newProjectStatus = (dashboardData.projectStatus || []).map(status => {
          // status.value represents count for that status for all projects
          // We attempt to filter projects assigned to employee to count properly

          // If you have `status.projects` list, filter from that (assuming)
          let filteredValue = 0;
          if (status.projects && status.projects.length) {
            filteredValue = status.projects.filter(proj => 
              proj.assignedTo && proj.assignedTo.includes(id)
            ).length;
          } else {
            // No detailed projects list; fallback to 0 or original count
            filteredValue = 0;
          }
          return { ...status, value: filteredValue };
        }).filter(s => s.value > 0);

        // Filter upcoming deadlines (projects / milestones) assigned to employee
        const newUpcomingDeadlines = (dashboardData.upcomingDeadlines || []).filter(item => 
          item.assignedTo && item.assignedTo.includes(id)
        );

        // Filter stats accordingly
        const totalProjects = newProjectStatus.reduce((sum, s) => sum + s.value, 0);
        const activeProjects = newProjectStatus.find(s => s.name.toLowerCase().includes('active'))?.value || 0;
        const completedProjects = newProjectStatus.find(s => s.name.toLowerCase() === 'completed')?.value || 0;

        setFilteredProjectStatus(newProjectStatus);
        setFilteredUpcomingDeadlines(newUpcomingDeadlines);
        setFilteredStats({
          ...stats,
          totalProjects,
          activeProjects,
          completedProjects
        });

      } else {
        // Company role, show all data
        setFilteredProjectStatus(dashboardData.projectStatus);
        setFilteredUpcomingDeadlines(dashboardData.upcomingDeadlines);
        setFilteredStats(stats);
      }
    } catch (e) {
      // If error, fallback to original data
      setFilteredProjectStatus(dashboardData.projectStatus);
      setFilteredUpcomingDeadlines(dashboardData.upcomingDeadlines);
      setFilteredStats(stats);
    }
  }, [dashboardData, stats]);

  return (
    <div className="space-y-6">
      {/* Project Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <MetricCard icon={<FolderOpen className="w-6 h-6" />} title="Total Projects" value={filteredStats.totalProjects} change="+10%" trend="up" color="blue" />
        <MetricCard icon={<Activity className="w-6 h-6" />} title="Active Projects" value={filteredStats.activeProjects} change="+15%" trend="up" color="green" />
        <MetricCard icon={<CheckCircle className="w-6 h-6" />} title="Completed" value={filteredStats.completedProjects} change="+5%" trend="up" color="purple" />
      </div>

      {/* Project Timeline */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Project Timeline</h3>
        {filteredProjectStatus.length > 0 ? (
          <div className="space-y-4">
            {filteredProjectStatus.map((status) => (
              <div key={status.name} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-gray-900">{status.name}</span>
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      status.name === 'Completed' ? 'bg-green-100 text-green-800' :
                      status.name === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {status.name}
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className={`h-2 rounded-full ${
                      status.name === 'Completed' ? 'bg-green-500' :
                      status.name === 'In Progress' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} style={{ width: `${(status.value / (filteredStats.totalProjects || 1)) * 100}%` }}></div>
                  </div>
                  <div className="flex justify-between text-xs text-gray-500 mt-1">
                    <span>{status.value} projects</span>
                    <span>Progress: {(status.value / (filteredStats.totalProjects || 1) * 100).toFixed(0)}%</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-8">No project data available</p>
        )}
      </div>

      {/* Recent Milestones Table */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Milestones</h3>
        {filteredUpcomingDeadlines.filter(d => d.type === 'Milestone').length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Project</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Due Date</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUpcomingDeadlines.filter(d => d.type === 'Milestone').slice(0, 5).map((milestone, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{milestone.title || milestone.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{milestone.projectName}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        milestone.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {milestone.status || 'In Progress'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(milestone.dueDate).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 text-center py-8">No milestones data available</p>
        )}
      </div>
    </div>
  );
};

export default ProjectsDashboard;
